// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// routes
import { paths } from 'src/routes/paths';
// locales
// components
import { RouterLink } from 'src/routes/components';
import { Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

export default function NavUpgradeMini() {
  const { user } = useMockedUser();

  const simpleUser = user?.userType === 'user' && paths.dashboard.user.profile;
  const organizer = user?.userType === 'organizer' && paths.orangizerDashboard.user.profile;
  const superAdmin = user?.userType === 'super-admin' && paths.superAdminDashboard.user.account;

  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Box
          sx={{ position: 'relative' }}
          component={RouterLink}
          to={simpleUser || organizer || superAdmin}
        >
          <Avatar src={user?.profileIcon} alt={user?.displayName} sx={{ width: 48, height: 48 }} />
        </Box>

        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2, maxWidth: '50px' }}>
          <Tooltip title={user?.displayName}>
            <Typography
              variant="subtitle2"
              noWrap
              component={RouterLink}
              to={simpleUser || organizer || superAdmin}
              sx={{
                textDecoration: 'none',
                color: 'text.primary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            >
              {user?.displayName}
            </Typography>
          </Tooltip>

          <Tooltip title={user?.email}>
            <Typography
              variant="body2"
              noWrap
              component={RouterLink}
              to={simpleUser || organizer || superAdmin}
              sx={{
                textDecoration: 'none',
                color: 'text.disabled',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            >
              {user?.email}
            </Typography>
          </Tooltip>
        </Stack>
      </Stack>
    </Stack>
  );
}
